import { GetterTree } from 'vuex';
import { IProgressListItem } from '@/onboarding-sidebar/types/progress-list-item';
import {
  IOnboardingState,
  EOnboardingGetter,
} from '@/onboarding-sidebar/store/onboarding.constants';
import { RootState } from '@/store/store';
import { EAbTestingGroup } from '@/enums/ab-testing';

export const getters: GetterTree<IOnboardingState, RootState> = {
  [EOnboardingGetter.AddedDocument](_, __, rootState: RootState): IProgressListItem {
    const { document } = rootState['documentEdit']['assembler'];
    return { label: 'add-document', completed: document?.pages.length > 0 };
  },
  [EOnboardingGetter.AddedRecipient](_, __, rootState: RootState): IProgressListItem {
    const { document } = rootState['documentEdit']['assembler'];
    return { label: 'add-recipient', completed: document?.recipients.length > 0 };
  },
  [EOnboardingGetter.AddedEngageVideo](_, __, rootState: RootState): IProgressListItem {
    const { isVideo } = rootState['documentEdit'];
    return { label: 'add-engage-video', completed: isVideo };
  },
  [EOnboardingGetter.SentDocument](_, __, rootState: RootState): IProgressListItem {
    const { user } = rootState['session'];
    return { label: 'send-your-first-document', completed: user.nbrDocumentsSent > 0 };
  },
  [EOnboardingGetter.ShowOnboarding](state: IOnboardingState, _, rootState: RootState): boolean {
    const { user } = rootState['session'];
    return (
      user.nbrDocumentsSent === 0 &&
      !state.hasSentFirstDocument &&
      state.showSidebar &&
      (state.onboardingGroup === EAbTestingGroup.MonitorProgress ||
        state.onboardingGroup === EAbTestingGroup.ReduceFrictionAndMonitorProgress)
    );
  },
};
